export { initDisableConsole } from './init-disable-console';

// not using this for now.  Only using init-disable-console.ts
// export { enableConsoleFromQueryParams as disableConsoleFromQueryParams } from './disable-console-from-query-params';
